import { init as initDatadogRum } from "@servicetitan/datadog-rum";
import { datadogGuard } from "./datadog-guard";
import { datadogRumBeforeSend } from "./datadog-rum-before-send";
import {
  DATADOG_RUM_APPLICATION,
  DATADOG_RUM_SERVICE_NAME,
} from "./datadog-rum-config";
import { getEnvironmentName } from "./environment";
import { isDatadogRumEnabled } from "./is-datadog-rum-enabled";

export function initializeDatadogRum(): void {
  const enabled = isDatadogRumEnabled(window.location.hostname);

  initDatadogRum({
    service: { name: DATADOG_RUM_SERVICE_NAME },
    application: {
      applicationId: DATADOG_RUM_APPLICATION.applicationId,
      clientToken: DATADOG_RUM_APPLICATION.clientToken,
      site: "datadoghq.com",
      env: getEnvironmentName(),
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: "mask-user-input",
      trackUserInteractions: true,
      trackResources: true,
      trackResourceHeaders: [
        { name: "x-st-correlationid", location: "response" },
      ],
      // application.beforeSend runs after the wrapper's built-in MFE enrichment;
      // path-only URLs keep tenantId/customerName/linkId out of RUM storage.
      beforeSend: datadogRumBeforeSend,
    },
    enabled,
  });

  if (enabled && window.DD_RUM) {
    datadogGuard(window.DD_RUM);
  }
}
